import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import AmenitiesIcon from '../../assets/images/water-activities.svg';
import ListingsIcon from '../../assets/images/listing.svg';
import SearchIcon from '../../assets/images/search.svg';
import WarningIcon from '../../assets/images/warning.svg';

import { Container } from './styled';

const ListingListState = ({ type }) => {
  const { t } = useTranslation();

  if (type === 'no_listings') {
    return (
      <Container>
        <img src={ListingsIcon} alt="Listings" />
        <h3>{t('no_listings', 'No listings')}</h3>
        <p>{t('no_listings_message', 'We don’t currently have any listings available.')}</p>
      </Container>
    );
  }

  if (type === 'no_amenities') {
    return (
      <Container>
        <img src={AmenitiesIcon} alt="Amenities" />
        <h3>{t('no_amenities', 'No Amenities')}</h3>
        <p>{t('no_amenities_message', 'We don’t currently have any amanities available.')}</p>
      </Container>
    );
  }

  if (type === 'not_found') {
    return (
      <Container>
        <img src={SearchIcon} alt="Search" />
        <h3>{t('no_results', 'No results found')}</h3>
        <p>{t('no_results_message', 'It seems we can’t find any listings that match your critera.')}</p>
      </Container>
    );
  }

  if (type === 'error') {
    return (
      <Container>
        <img src={WarningIcon} alt="Warning" />
        <h3>{t('failed', 'Failed to load listings')}</h3>
        <p>{t('failed_message', 'Something’s gone wrong. Try refreshing the page.')}</p>
      </Container>
    );
  }

  if (type === 'not_found_404') {
    return (
      <Container>
        <img src={WarningIcon} alt="Error" />
        <h3>{t('not_found', '404')}</h3>
        <p>{t('not_found_message', 'Page does not exist')}</p>
      </Container>
    );
  }

  return null;
};

ListingListState.propTypes = {
  type: PropTypes.oneOf(['not_found', 'no_listings', 'no_amenities', 'error', 'not_found_404']).isRequired,
};

export default ListingListState;
